module.exports = __webpack_public_path__ + "static/media/NIFTYINFRA.bebd2b09.txt";